var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTemporary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1846 24.1545H8.73205C8.5719 21.432 9.69295 15.8908 15.4584 15.5065C21.2237 15.1221 22.3448 9.58094 22.1846 6.8584H8.73205",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73205 6.8584C8.5719 9.58093 9.69295 15.1221 15.4584 15.5065C21.2237 15.8908 22.3448 21.432 22.1846 24.1545",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9302 9.61359H11.9868C12.1797 10.7366 13.144 12.9826 15.4585 12.9826C17.7729 12.9826 18.7373 10.7366 18.9302 9.61359Z",
    fill: "#484848",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgTemporary;